import { supabase } from './supabase';

export const defaultBusinessProfile = {
  brand_name: 'BW Station',
  legal_name: 'BW Station',
  tagline: '',
  address: '',
  phone_primary: '',
  phone_secondary: '',
  support_email: '',
  website: '',
  logo_url: '',
};

export async function fetchBusinessProfile() {
  const { data, error } = await supabase
    .from('business_profile')
    .select('*')
    .eq('id', true)
    .maybeSingle();
  if (error) throw error;
  return { ...defaultBusinessProfile, ...(data || {}) };
}
